import React, { useContext, useState } from 'react';
import _ from 'lodash';

import { RestApiContext } from '../../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../../helpers';
import { addBundleItem, updateBundleItem, removeBundleItem } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [pageIsReady, setPageIsReady] = useState(false);
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [state, setState] = useAggregatedState({
        bundle: null,
        tables: null
    });

    const apiClient = useContext(RestApiContext);

    const getTablesAsync = async (tableName, withUsers, pageIndex, pageSize) => {
        try {
            const bundle = await apiClient.getManagedTablesAsync(tableName, withUsers, pageIndex, pageSize);
            setState({ bundle, tables: bundle.items });
        } catch (e) {
            console.debug(e);
        }
    }

    const toggleTableAvailabilityAsync = async ({ tableId, isDisabled }) => {
        try {
            const table = await apiClient.toggleTableAvailabilityAsync({ tableId, isDisabled });
            const bundle = updateBundleItem(state.bundle, table, (x) => x.managedTableId === tableId);
            setState({ bundle, tables: bundle.items });
        } catch (e) {
            console.debug(e);
        }
    }

    const toggleTableAllowImportAsync = async ({ tableId, allowImport }) => {
        try {
            const table = await apiClient.toggleTableAllowImportAsync({ tableId, allowImport });
            const bundle = updateBundleItem(state.bundle, table, (x) => x.managedTableId === tableId);
            setState({ bundle, tables: bundle.items });
        } catch (e) {
            console.debug(e);
        }
    }

    const toggleTableClearOnImportAsync = async ({ tableId, clearOnImport }) => {
        try {
            const table = await apiClient.toggleTableClearOnImportAsync({ tableId, clearOnImport });
            const bundle = updateBundleItem(state.bundle, table, (x) => x.managedTableId === tableId);
            setState({ bundle, tables: bundle.items });
        } catch (e) {
            console.debug(e);
        }
    }

    const syncExternalTablesAsync = async () => {
        try {
            await apiClient.syncExternalTablesAsync();
        } catch (e) {
            console.debug(e);
        }
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getTablesAsync,
            toggleTableAvailabilityAsync,
            toggleTableAllowImportAsync,
            toggleTableClearOnImportAsync,
            syncExternalTablesAsync
        }}>
            {props.children}
        </Provider>
    );
}